// eslint-disable-next-line
export default {
    // Auth
    "auth.login": "Connexion",
    "auth.email": "Email",
    "auth.password": "Mot de passe",
    "auth.enterEmail": "Entrez votre email",
    "auth.enterPassword": "Entrez votre mot de passe",
    "auth.loginButton": "Se connecter",
    "auth.loggingIn": "Connexion en cours...",
    "auth.loginTitle": "Connexion au système",
    "auth.loginDescription": "Entrez votre email et votre mot de passe pour vous connecter",
    "auth.logout": "Se déconnecter",
    "auth.authError": "Erreur d'authentification",

    // Common
    "common.loading": "Chargement...",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.delete": "Supprimer",
    "common.edit": "Modifier",
    "common.create": "Créer",
    "common.close": "Fermer",
    "common.confirm": "Confirmer",
    "common.yes": "Oui",
    "common.no": "Non",
    "common.search": "Rechercher",
    "common.filter": "Filtre",
    "common.settings": "Paramètres",
    "common.active": "Actif",
    "common.inactive": "Inactif",
    "common.blocked": "Bloqué",
    "common.total": "Total",
    "common.deleteUser": "Supprimer l'utilisateur",
    "common.resetPassword": "Réinitialiser le mot de passe",
    "common.confirmDelete": "Confirmer la suppression",
    "common.deleteConfirmText": "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.",

    // Roles
    "role.admin": "Administrateur",
    "role.teacher": "Enseignant",
    "role.student": "Étudiant",

    // Navigation
    "nav.dashboard": "Tableau de bord",
    "nav.users": "Utilisateurs",
    "nav.students": "Étudiants",
    "nav.teachers": "Enseignants",
    "nav.courses": "Cours",
    "nav.schedule": "Emploi du temps",
    "nav.grades": "Notes",
    "nav.last_entry": "Dernier accès",
    "nav.visits": "Visites",
    "nav.never": "Jamais",

    // Admin Dashboard
    "admin.title": "Tableau de bord administrateur",
    "admin.createTeacher": "Créer un enseignant",
    "admin.systemUsers": "Utilisateurs du système",
    "admin.userManagement": "Gestion de tous les utilisateurs du système",
    "admin.stats.admins": "Admins",
    "admin.stats.teachers": "Enseignants",
    "admin.stats.students": "Étudiants",
    "admin.block": "Bloquer",
    "admin.unblock": "Débloquer",

    // Teacher Dashboard
    "teacher.title": "Tableau de bord de l'enseignant",
    "teacher.inviteStudent": "Inviter un étudiant",
    "teacher.myStudents": "Mes étudiants",
    "teacher.studentManagement": "Gestion des étudiants dans vos groupes",
    "teacher.noStudents": "Vous n'avez pas encore d'étudiants",
    "teacher.inviteFirst": "Invitez votre premier étudiant en cliquant sur le bouton ci-dessus",
    "teacher.addedOn": "Ajouté le :",

    // Student Dashboard
    "student.title": "Espace personnel de l'étudiant",
    "student.personalInfo": "Informations personnelles",
    "student.yourData": "Vos données dans le système",
    "student.fullName": "Nom complet",
    "student.role": "Rôle",
    "student.status": "Statut",
    "student.courses": "Cours",
    "student.coursesDesc": "Mes cours et supports",
    "student.schedule": "Emploi du temps",
    "student.scheduleDesc": "Horaires des cours",
    "student.grades": "Notes",
    "student.gradesDesc": "Mes notes et résultats",
    "student.notifications": "Notifications",
    "student.updates": "Dernières mises à jour et annonces",
    "student.welcome": "Bienvenue dans le système !",
    "student.welcomeDesc":
        "Vous avez été enregistré avec succès dans le système de gestion de l'école. Ici, vous pouvez consulter vos cours, votre emploi du temps et vos notes.",
    "student.today": "Aujourd'hui",
    "student.featuresInDev": "Fonctionnalités en développement",
    "student.featuresDesc":
        "Des fonctionnalités supplémentaires pour les étudiants (cours, devoirs, notes) seront ajoutées dans les futures versions du système.",
    "student.info": "Information",

    // Password Change
    "password.change": "Changement de mot de passe",
    "password.new": "Nouveau mot de passe",
    "password.confirm": "Confirmez le mot de passe",
    "password.required": "Vous devez changer votre mot de passe temporaire pour continuer",
    "password.enter": "Entrez un nouveau mot de passe pour votre compte",
    "password.minLength": "6 caractères minimum",
    "password.repeat": "Répétez le nouveau mot de passe",
    "password.saving": "Enregistrement en cours...",
    "password.success": "Mot de passe changé avec succès",
    "password.error": "Erreur lors du changement de mot de passe",
    "password.minError": "Le mot de passe doit contenir au moins 6 caractères",
    "password.mismatch": "Les mots de passe ne correspondent pas",

    // Create Teacher Modal
    "createTeacher.title": "Créer un enseignant",
    "createTeacher.description":
        "Entrez les informations du nouvel enseignant. Une invitation sera envoyée à l'adresse e-mail spécifiée.",
    "createTeacher.fullName": "Nom complet",
    "createTeacher.fullNamePlaceholder": "Jean Dupont",
    "createTeacher.emailPlaceholder": "enseignant@ecole.fr",
    "createTeacher.creating": "Création en cours...",
    "createTeacher.success": "Enseignant créé avec succès",
    "createTeacher.error": "Erreur lors de la création de l'enseignant",
    "createTeacher.exists": "Un utilisateur avec cet email existe déjà",

    // Invite Student Modal
    "inviteStudent.title": "Inviter un étudiant",
    "inviteStudent.description": "Entrez les informations du nouvel étudiant. Une invitation sera envoyée à l'adresse e-mail spécifiée.",
    "inviteStudent.fullName": "Nom complet",
    "inviteStudent.fullNamePlaceholder": "Pierre Martin",
    "inviteStudent.emailPlaceholder": "etudiant@ecole.fr",
    "inviteStudent.sending": "Envoi de l'invitation...",
    "inviteStudent.success": "Étudiant invité avec succès",
    "inviteStudent.error": "Erreur lors de l'invitation de l'étudiant",

    // System
    "system.title": "Système d'enseignement à distance",
    "system.error": "Erreur système",
    "system.networkError": "Erreur réseau",
    "system.unauthorized": "Accès non autorisé",
    "system.forbidden": "Accès refusé",
    "system.notFound": "Non trouvé",
    // Trainers
    "messages.userDeleted": "Utilisateur supprimé avec succès",
    "messages.passwordReset": "Le mot de passe a été réinitialisé et envoyé par email",
    "messages.deleteError": "Erreur lors de la suppression de l'utilisateur",
    "messages.resetError": "Erreur lors de la réinitialisation du mot de passe",

    "training.start": "Commencer l'entraînement",
    "trainings.title": "Modules d'entraînement",
    "trainings.memory": "Entraînement de la mémoire",
    "trainings.memory.description": "Exercices pour entraîner la mémoire des étudiants",
    "trainings.logic": "Problèmes de logique",
    "trainings.logic.description": "Problèmes de logique et énigmes pour les étudiants",
    "trainings.back": "Retour",
    "trainig.notImplemented": "Ce module d'entraînement n'est pas encore implémenté",
    // Mental arithmetics
    "trainings.mental": "Calcul mental",
    "trainings.mental.description": "Entraînement au calcul mental pour les étudiants",
    "mentalArithmetic": "Calcul mental",
    "trainer": "Entraîneur",
    "flashCards": "Cartes mémoire",
    "additionSubtraction": "Addition / Soustraction",
    "multiplicationDivision": "Multiplication / Division",
    "selectTrainerSettings": "Sélectionnez les paramètres de l'entraîneur",
    "selectCardsSettings": "Sélectionnez les paramètres des cartes",
    "selectMultiSettings": "Sélectionnez les paramètres de l'entraîneur",
    "go": "Partez",
    "theme": "Thème",
    "difficulty": "Difficulté",
    "digits": "Nombre de chiffres",
    "actionsCount": "Nombre d'actions",
    "inputTime": "Temps de réponse",
    "speed": "Vitesse",
    "start": "Démarrer",
    "stop": "Arrêter",
    "settings": "Paramètres",
    "continue": "Continuer",
    "simple": "Simple",
    "brother": "Frère",
    "friend": "Ami",
    "friendBrother": "Ami + Frère",
    "transitions": "Passages",
    "allThemes": "Tous les thèmes",
    "multiplication": "Multiplication",
    "division": "Division",
    "squaring": "Mise au carré",
    "performExercise": "Faites l'exercice",
    "yourAnswer": "Votre réponse :",
    "correct": "Correct",
    "incorrect": "Incorrect",
    "answer": "Réponse",
    "sec": "sec",
    "multiplier": "Multiplicateur",
    "divisor": "Diviseur",
    "any": "N'importe lequel",
    "multiplicationTable": "Table de multiplication",
    "byMultiplicationTable": "Par la table de multiplication",
    "resetAllSettings": "Réinitialiser tous les paramètres et recharger la page ?",
    "difficulties": {
        "0-4": "0-4",
        "0-5": "0-5",
        "0-6": "0-6",
        "0-7": "0-7",
        "0-8": "0-8",
        "0-9": "0-9",
        "4": "4",
        "3": "3",
        "2": "2",
        "1": "1",
        "9": "9",
        "8": "8",
        "7": "7",
        "6": "6",
        "5": "5",
        "50Plus": "50 +",
        "50Minus": "50 -",
        "100Plus": "100 +",
        "100Minus": "100 -"
    },
    "multiDifficulties": {
        "multiplicationTable": "Table de multiplication",
        "2x1": "II x I",
        "3x1": "III x I",
        "2x2": "II x II",
        "4x1": "IIII x I",
        "3x2": "III x II",
        "base50": "Base 50",
        "base100": "Base 100",
        "base200": "Base 200",
        "byMultiplicationTable": "Par la table de multiplication",
        "2div1": "II / I",
        "3div1": "III / I",
        "4div1": "IIII / I",
        "2div2": "II / II",
        "3div2": "III / II",
        "4div2": "IIII / II",
        "4div3": "IIII / III",
        "2-10": "2-10",
        "on5": "par 5",
        "11-19": "11-19",
        "20-30": "20-30",
        "30-70": "30-70",
        "80-120": "80-120"
    },
    "multiThemes": {
        "multiplication": "Multiplication",
        "division": "Division",
        "squaring": "Mise au carré"
    },
    "cardsDifficulties": {
        "0-4": "0-4",
        "0-9": "0-9"
    }
}